import React, { forwardRef } from 'react';
import DragHandleIcon from '@material-ui/icons/DragHandle';

export const Handle = forwardRef((props, ref) => {
	return <DragHandleIcon className='item-drag' ref={ref as any} {...props} />;
});

export default Handle;
